import { isNonNullable, narrowType } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaTreeContext } from 'components/SecuritySchema/SecuritySchemaTreeContext';
import type { SecuritySchemaModel } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { selectRuleChainScope } from 'components/SecuritySchema/model/selectors/selectRuleChainScope';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import { selectPaginatedHighlightedRuleIndex } from './selectPaginatedHighlightedRuleIndex';

export const selectSecuritySchemaTreeContext: (
  s: SecuritySchemaModel,
) => SecuritySchemaTreeContext = createScopedSelector(() =>
  createSelector(
    prop<SecuritySchemaModel, 'dispatch'>('dispatch'),
    selectPaginatedHighlightedRuleIndex,
    prop('treeScrollContainerRef'),
    flow(selectRuleChainScope, narrowType(isNonNullable), prop('securityType')),
    (
      dispatch,
      paginatedHighlightedRuleIndex,
      treeScrollContainerRef,
      securityType,
    ) => ({
      dispatch,
      paginatedHighlightedRuleIndex,
      treeScrollContainerRef,
      securityType,
    }),
  ),
);
